import { defineSlotRecipe } from '@chakra-ui/react';
export const numberInputRecipe = defineSlotRecipe({
    className: 'chakra-number-input',
    slots: ['root', 'input', 'control', 'incrementTrigger', 'decrementTrigger'],
    base: {
        root: {
            position: 'relative',
            display: 'inline-flex',
            width: '100%',
            colorPalette: 'primary',
        },
        input: {
            width: '100%',
            minWidth: 0,
            outline: 'transparent solid 2px',
            outlineOffset: '0.5px',
            position: 'relative',
            appearance: 'none',
            transitionProperty: 'common',
            transitionDuration: 'normal',
            borderTopRightRadius: 'md',
            borderBottomRightRadius: 'md',
            _disabled: {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
        },
        control: {
            display: 'flex',
            flexDirection: 'column',
            borderTopRightRadius: 'md',
            borderBottomRightRadius: 'md',
            overflow: 'hidden',
        },
        incrementTrigger: {
            borderTopRightRadius: 'md',
        },
        decrementTrigger: {
            borderBottomRightRadius: 'md',
        },
    },
    variants: {
        variant: {
            outline: {
                input: {
                    borderWidth: '1px',
                    borderColor: 'border',
                    bg: 'bg',
                    borderTopLeftRadius: 'md',
                    borderBottomLeftRadius: 'md',
                    _hover: {
                        borderColor: 'border.emphasized',
                    },
                    _focus: {
                        outline: '2px solid',
                        outlineOffset: '0.5px',
                        outlineColor: 'colorPalette.focusRing/15',
                        zIndex: 1,
                        borderColor: 'colorPalette.focusRing',
                        boxShadow: '0 0 0 1px var(--chakra-colors-colorPalette-focusRing)',
                    },
                    _invalid: {
                        borderColor: 'border.error',
                        _focus: {
                            borderColor: 'border.error',
                            boxShadow: '0 0 0 1px var(--chakra-colors-border-error)',
                        },
                    },
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outline',
    },
});
